import * as yup from 'yup';

/**
 * E38 · Safety Plan — the both-ends input codecs of the plan's mutations (plan 03 §2.1 #3): the phone (before it
 * saves), the portal and — as the shield's inputRule — the API run the SAME schema. Shape only; the business rules
 * (an unknown section, more than ten entries, a contact without a name, who may edit) are the decider's, where they
 * are binding and answer with the board's code in the person's language. `subject` is ABSENT from the client's own
 * commands on purpose (the caller is the subject); `performer` is never on the wire.
 *
 * An entry is one of two shapes: a line of text (`text`) or a person / place (`name`, with an optional `phone` and
 * `kind`). The API turns it into the fact's `string | {name, phone, kind}`.
 */
const userRef = yup
  .string()
  .trim()
  .matches(/^users\/[A-Za-z0-9_-]{1,64}$/);

const uuidV7 = yup
  .string()
  .trim()
  .matches(
    /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
  )
  .required();

export const safetyPlanEntryInputSchema = yup.object({
  text: yup.string().max(2000).nullable(),
  name: yup.string().max(2000).nullable(),
  phone: yup.string().max(64).nullable(),
  kind: yup.string().oneOf(['person', 'place']).nullable(),
});

const section = yup.string().trim().min(1).max(64).required();
// the count (10) is the decider's board code, not a generic validation error; a generous cap stops abuse
const entries = yup
  .array()
  .of(safetyPlanEntryInputSchema.required())
  .max(100)
  .required();

export const updateSafetyPlanSectionInputSchema = yup.object({
  section,
  entries,
});

export const updateSafetyPlanSectionInSessionInputSchema = yup.object({
  subject: userRef.required(),
  section,
  entries,
});

export const reviewSafetyPlanInputSchema = yup.object({
  subject: userRef.required(),
  nextReviewBy: yup
    .string()
    .trim()
    .matches(/^\d{4}-\d{2}-\d{2}$/)
    .nullable(),
  note: yup.string().max(2000).nullable(),
});

export const recordSafetyPlanOpenedInputSchema = yup.object({
  openedId: uuidV7,
  openedFrom: yup.string().trim().min(1).max(32).required(),
  openedAt: yup.date().nullable(),
});

/** The mutation ARGUMENTS — what the shield's inputRules validate. */
export const updateSafetyPlanSectionArgsSchema = yup.object({
  input: updateSafetyPlanSectionInputSchema.required(),
});
export const updateSafetyPlanSectionInSessionArgsSchema = yup.object({
  input: updateSafetyPlanSectionInSessionInputSchema.required(),
});
export const reviewSafetyPlanArgsSchema = yup.object({
  input: reviewSafetyPlanInputSchema.required(),
});
export const recordSafetyPlanOpenedArgsSchema = yup.object({
  input: recordSafetyPlanOpenedInputSchema.required(),
});

export const safetyPlanValidators = {
  updateSafetyPlanSectionInputSchema,
  updateSafetyPlanSectionInSessionInputSchema,
  reviewSafetyPlanInputSchema,
  recordSafetyPlanOpenedInputSchema,
  updateSafetyPlanSectionArgsSchema,
  updateSafetyPlanSectionInSessionArgsSchema,
  reviewSafetyPlanArgsSchema,
  recordSafetyPlanOpenedArgsSchema,
};
